import {useEffect, useRef} from 'react'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import {useGetUnreadCountQuery} from '../CorrespondenceApiSlice'
import {useAuth} from 'react-oidc-context'
import {useCorrespondenceHost} from '../host/CorrespondenceHostContext'

export function useCorrespondenceNotifier() {
  const auth = useAuth()
  const navigate = useNavigate()
  const host = useCorrespondenceHost()
  const isAuthenticated = auth.isAuthenticated

  const {data} = useGetUnreadCountQuery(undefined, {
    skip: !isAuthenticated,
  })

  const prevCountRef = useRef<number | null>(null)

  useEffect(() => {
    if (data == null) return

    const current = data.total

    if (prevCountRef.current !== null && current > prevCountRef.current) {
      const newCount = current - prevCountRef.current
      toast.info(
        <span
          style={{cursor: 'pointer'}}
          onClick={() => navigate(host.inboxRoute())}
        >
          You have {newCount} new message{newCount !== 1 ? 's' : ''}. Click to view.
        </span>,
        {autoClose: 6000}
      )
    }

    prevCountRef.current = current
  }, [data, host, navigate])
}
